import { Component } from 'react'
import SkillsTreeModal from '../../Modals/SkillsTreeModal/SkillsTreeModal.jsx'

class SkillsTreeButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal
    }))
  }

  render() {
    return (
      <div>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={this.toggle}
        >
          Voir l'arbre de compétences
        </button>

        <SkillsTreeModal
          modal={this.state.modal}
          toggle={this.toggle}
        />
      </div>
    )
  }
}

export default SkillsTreeButton